import Accordion from 'accordion-js';

export default {
  init() {
    // JavaScript to be fired on all pages

    /** GLOBAL VARIABLES */
    var body = document.querySelector('body'),
        mobileNav       = document.querySelector('#mobile-nav'),
        mobileNavButton = document.querySelector('#mobile-nav-icon');
    /** END GLOBAL VARIABLES */

    /** SKIP LINK NAVIGATION */
    $('#skip-to-content').click(function () {
      // strip the leading hash and declare
      // the content we're skipping to
      var skipTo = "#" + this.href.split('#')[1];
      // Setting 'tabindex' to -1 takes an element out of normal 
      // tab flow but allows it to be focused via javascript
      $(skipTo).attr('tabindex', -1).on('blur focusout', function () {
        // when focus leaves this element, 
        // remove the tabindex attribute
        $(this).removeAttr('tabindex');
      }).focus(); // focus on the content container
    });
    /** END SKIP LINK NAVIGATION */

    /* HEADER SCROLL EFFECT */
    // Reference: http://tympanus.net/codrops/2013/06/06/on-scroll-animated-header/
    var animatedHeader = (function () { // eslint-disable-line no-unused-vars
        var didScroll    = false,
            scrollOffset = 0;
  
        function scrollY() {
            return window.pageYOffset || document.documentElement.scrollTop;
        }
  
        function scrollPage() {
            var sy = scrollY();
            if (sy > scrollOffset) {
                body.classList.add('scroll-triggered');
            }
            else {
                body.classList.remove('scroll-triggered');
            }
            didScroll = false;
        }
  
        function init() {
            window.addEventListener('load', scrollPage);
            window.addEventListener('scroll', function (event) { // eslint-disable-line no-unused-vars
               console.log(scrollY);
  
                if (!didScroll) {
                    didScroll = true;
                    setTimeout(scrollPage, 50);
                }
            }, false);
        }
        init();
      })();
      /* END HEADER SCROLL EFFECT */

    /** RESPONSIVE NAV OPEN/CLOSE **/
    // Toggle menu icon
    if (mobileNavButton) {
        mobileNavButton.addEventListener('click', function () {
            body.classList.toggle('mobile-nav-open');
        });
    }

    // Close menu if page is clicked (not menu item)
    if (mobileNav) {
        mobileNav.addEventListener('click', function (e) {
          // Don't hide if click is on a child element (nav link)
          if (e.target !== this) {
            return;
          }
          mobileNavButton.classList.toggle('opened');
          $("#nav-toggle").prop('checked', false);
        });
  
        // Disable click on mobile
        $("#mobile-nav .menu-item-has-children > .sub-menu--open").on("click", function () {
          $(this).parent('.menu-item').toggleClass("mobile-nav--opened");
        });
    }
    
    /** MASTHEAD PRGRESSIVE IMAGES **/
    var masthead = document.querySelector('.masthead__image'),
        placeholderOverlay = document.querySelector('.masthead__overlay');

    if (masthead && placeholderOverlay) {
        // Load full size image. When loaded, fade our placeholder add it as bg to masthead
        var img = new Image();
        img.src = masthead.dataset.imageSrc;
        img.onload = function () {
            placeholderOverlay.classList.add('fade-out');
            masthead.style.backgroundImage = "url(" + img.src + ")";
        };
    }
    /** END MASTHEAD PRGRESSIVE IMAGES **/

    /** ANIMATED ANCHOR LINKS **/
    $('a[href*="#"]:not([href="#"])').click(function (e) {
        // Doesn't do it on page builder tabs
        if (!$(this).closest('li').hasClass('vc_tta-tab')) {
            if (!$(this).closest('h4').hasClass('vc_tta-panel-title')) {
                if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                    var target = $(this.hash);
                    var $this = this;
                    var header = $('header.header');
                    var wpAdminBar = $('#wpadminbar');
                    var fixedHeaderOffset = parseInt(header.outerHeight()) - parseInt(header.css("padding-top").replace("px", ""));
                    // If we're logged in and WP ADmin Bar exists, add it to the offset
                    if ( wpAdminBar.length ) {
                        fixedHeaderOffset += parseInt(wpAdminBar.outerHeight());
                    }
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    if (target.length) {
                        $('html,body').animate({
                            scrollTop: (target.offset().top - fixedHeaderOffset),
                        }, 500, function () {
                            if (history.pushState) {
                                history.pushState(null, null, $this.hash);
                            }
                            else {
                                location.hash = $this.hash;
                            }
                        });
                        e.preventDefault();
                    }
                }
            }    
        }    
    });
    /** END ANIMATED ANCHOR LINKS **/

    /** SCROLL TO TOP */
    if( $('.to-top').length > 0) {
        $(document).scroll(function() {
            var y = $(this).scrollTop();
            if (y > 400) {
            $('.to-top').fadeIn(250);
            } else {
            $('.to-top').fadeOut(250);
            }
        });
    }

    /** Break link text to new line when link text is a URL **/
    $(document).ready(function(){
        $('a').each(function() {
            var $this = $(this);
            var innerLink = $this.text();
            if (innerLink.startsWith('http')) {
                $this.css('word-break','break-all');
            }
        });
    });
    /** End Break link text to new line when link text is a URL **/

    // slick slide
    if ($('.visceral-slider').length > 0) {
        var slider = $('.visceral-slider > .wpb_column > .vc_column-inner > .wpb_wrapper');

        slider.slick({
            slide         : '.visceral-slider > .wpb_column > .vc_column-inner > .wpb_wrapper > *',
            autoplay      : true,
            autoplaySpeed : 5000,
            fade          : true,
            speed         : 1000,
            infinite      : true,
            // centerMode    : true,
            // centerPadding : '50px',
            cssEase       : 'ease',
            slidesToShow  : 1,
            slidesToScroll: 1,
            swipeToSlide  : true,
            dots          : true,
            arrows        : false,
            mobileFirst   : true,
            rows          : 0,
        });
    }

    // slick slide - featured resources
    if ($('.list-wrap--featured-resources').length > 0) {
        var featuredResources = $('.list-wrap--featured-resources');
        featuredResources.slick({
            slidesToShow: 3,
            arrows      : false,
            infinite    : false,
            dots        : true,
            rows        : 0,
            responsive  : [
                {
                    breakpoint: 768, // max width 
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 576, // max width 
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });
    }

    // slick slide - featured cw posts
    if ($('.list-wrap--slider').length > 0) {
        var events = $('.list-wrap--slider');
        events.slick({
            slide         : '.list-item',
            slidesToShow  : 1,
            slidesToScroll: 1,
            arrows        : false,
            infinite      : false,
            dots          : true,
            rows          : 0,
        });
    }

    // slick slide - featured posts
    if ($('.listing--slider').length > 0) {
        var posts = $('.listing--slider');
        posts.slick({
            slide       : '.list-item',
            slidesToShow: 4,
            arrows      : false,
            infinite    : false,
            dots        : true,
            rows        : 0,
            responsive  : [
                {
                    breakpoint: 768, // max width 
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 576, // max width 
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });
    }

    // Accordions
    if ($('.tab__sections').length > 0) {
        new Accordion('.tab__sections', {
            showItem     : true,
            elementClass : 'tab__section',
            questionClass: 'tab__title',
            answerClass  : 'tab__body',
            onToggle     : function(currentElement) {
                var id = currentElement.id;
                $('.tab__image, .background-overlay__image').removeClass('is-active');
                $('.tab__image[data-id="' + id + '"]').toggleClass('is-active');
                $('.background-overlay__image[data-id="' + id + '"]').toggleClass('is-active');
            },
        });
    }

    // Rotating Tweets
    // slick slide
    if ($('.rotatingtweets').length > 0) {
        var tweets = $('.rotatingtweets');

        tweets.slick({
            autoplay      : true,
            autoplaySpeed : 5000,
            speed         : 800,
            infinite      : true,
            centerMode    : true,
            cssEase       : 'ease',
            slidesToShow  : 1,
            slidesToScroll: 1,
            swipeToSlide  : true,
            dots          : true,
            arrows        : false,
            fade          : true,
        });
    }

    // Search and filter tweaks
    // Trigger date field to update from custom years dropdown
    if ($('#years').length > 0) {
        // Years select
        var $y = '',
            $yearsSelect = $('#years');

        // S&F uses a date range picker with a min and max value in mm/dd/yyyy format
        // when a year is selected, set the min value to 1/1 and max to 12/31 to set the range for the entire selected year
        
        // Change S&F datepicker when year dropdown is changed
        $yearsSelect.on('change', function(){
            $y = $(this).val();

            let $minDate = $('.sf_date_field li:first-child .sf-datepicker');
            let $maxDate = $('.sf_date_field li:last-child .sf-datepicker');

            // reset if value is empty
            if( $y === '' ) {
                $minDate.val('');
                $maxDate.val('');
            } else {
                $minDate.val('01/01/' + $y); // update min date
                $maxDate.val('31/12/' + $y); // update max date
            }

            $(".searchandfilter").submit(); // submit form to initiate ajax
        });
    }

    // Trigger posts per page field to update from custom dropdown
    if ($('#per_page').length > 0) {
        var $ppp = $("#per_page"),
            $pp  = '';

        $ppp.on('change', function(){
            $pp = $(this).val();
            $('.sf-field-posts_per_page .sf-input-select').val($pp);
            $(".searchandfilter").submit(); // submit form to initiate ajax
        });
    }

    // Trigger sort by field to update from custom dropdown
    if($('#sort_by').length > 0) {
        var $sort_by = $('#sort_by'),
            $sort    = '';

        $sort_by.on('change', function() {
            $sort = $(this).val();
            $('.sf-field-sort_order .sf-input-select').val($sort);
            $(".searchandfilter").submit();
        });
    }

    // Search and Filter mobile toggles
    $(window).load(function(){
        
        if ($('.searchandfilter').length > 0) {
            // Determine height of filter list
            $('.searchandfilter li[class^="sf-field"]').each(function(){
                let li     = $(this);
                let height = $(this).children('ul').outerHeight();

                // Add show more icon
                if( height > 300 ) {
                    li.append('<h6><a class="sf-height-toggle" href="#">Show more/less</a></h6>');
                    if( li.hasClass('sf-field-taxonomy-issue') && (window.innerWidth > 768) ) { // Display all Issues intitially, desktop only
                        $(this).find('.sf-height-toggle').html('<span class="sf-height-toggle-text">Show less</span> <i class="icon-chevron-up" aria-hidden="true"></i>');

                        // On icon click, toggle options
                        $(this).find('.sf-height-toggle').click(function(e) {
                            e.preventDefault();
                            if( $(this).closest('li').children('ul').hasClass('sf-collapsed') ) { // open
                                $(this).closest('li').children('ul').animate({ height: height }, 600).removeClass('sf-collapsed');
                                $(this).html('<span class="sf-height-toggle-text">Show less</span> <i class="icon-chevron-up" aria-hidden="true"></i>');
                            } else { //collapse
                                $(this).closest('li').children('ul').animate({ height: 300 }, 600).addClass('sf-collapsed');
                                $(this).html('<span class="sf-height-toggle-text">Show more</span> <i class="icon-chevron-down" aria-hidden="true"></i>');
                            }
                        });
                    } else {
                        let toggle = $(this).find('.sf-height-toggle');
                        li.children('ul').addClass('sf-collapsed');
                        toggle.html('<span class="sf-height-toggle-text">Show more</span> <i class="icon-chevron-down" aria-hidden="true"></i>');

                        // On icon click, toggle options
                        toggle.toggle(function() {
                            $(this).html('<span class="sf-height-toggle-text">Show less</span> <i class="icon-chevron-up" aria-hidden="true"></i>');
                            $(this).closest('li').children('ul').animate({ height: height }, 600).removeClass('sf-collapsed');
                        }, function() {
                            $(this).html('<span class="sf-height-toggle-text">Show more</span> <i class="icon-chevron-down" aria-hidden="true"></i>');
                            $(this).closest('li').children('ul').animate({ height: 300}, 600).addClass('sf-collapsed');
                        });
                    }
                }
            });
        }
    });

    // Reveal animation using waypoints
    function itemReveal() {
        var waypoints = $('.reveal').waypoint({ // eslint-disable-line no-unused-vars
            handler: function(direction) { // eslint-disable-line no-unused-vars
              $(this)[0].classList.add('revealed');
            },
            offset: '85%',
        });
  
        var waypointChildren = $('.reveal--children > .wpb_wrapper > *').waypoint({ // eslint-disable-line no-unused-vars
            handler: function(direction) { // eslint-disable-line no-unused-vars
            $(this)[0].element.classList.add('revealed');
            },
            offset: '85%',
        });
      }
  
      itemReveal();

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// /Users/mishatrombley/Documents/Sites/aurora-institute/app/public/wp-content/themes/aurora-institute/resources/assets/scripts/routes/common.js